import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Msisdn } from '../../../../shared/msisdn/msisdns';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-mapping-assigned-number',
  templateUrl: './mapping-assigned-number.component.html',
  styleUrls: ['./mapping-assigned-number.component.scss']
})
export class MappingAssignedNumberComponent implements OnInit, OnChanges {
  @Input() editMode: boolean;
  @Input() form: FormGroup;
  @Input() msisdns: Msisdn[];

  @Output() public changeEditMode = new EventEmitter();
  @Output() public delete = new EventEmitter();
  @Output() public changed = new EventEmitter();

  public selectedMsisdn;

  ngOnInit(): void {
    this.form.get('msisdnId').valueChanges.subscribe(msisdnId => this.setSelectedMsisdn(msisdnId));
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setSelectedMsisdn(this.form.get('msisdnId').value);
  }

  setSelectedMsisdn(msisdnId) {
    if (this.msisdns) {
      this.selectedMsisdn = this.msisdns.find(el => el.id === msisdnId);
    }
  }

  onSelectChange(event, selectedMsisdn) {
    this.form.patchValue({
      ...selectedMsisdn,
      msisdnId: event.value
    });
  }

  isAddPhoneNumber() {
    return this.editMode && this.form.get('callerIdLabel').value;
  }
}
